import Swal from 'sweetalert2'
import {deleteAction} from '../../../../components/requests'

// Suppression d'une action
export function removeAction(actionId, setActions) {
  Swal.fire({
    title: 'Attention',
    text: 'Merci de confirmer la suppression',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Confirmer',
    cancelButtonText: 'Annuler',
    confirmButtonColor: '#1BC5BD',
    cancelButtonColor: '#F64E60',
    showLoaderOnConfirm: true,
    allowOutsideClick: () => !Swal.isLoading(), // empêche de fermer pendant le chargement
    preConfirm: async () => {
      const response = await deleteAction(actionId)
      if (response?.status === 200) {
        setActions((prev) => prev.filter((a) => a.id !== actionId))
        return true
      } else {
        throw new Error('Échec de la suppression.')
      }
    },
  })
    .then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Supprimée',
          text: 'L’action a bien été supprimée.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        })
      }
    })
    .catch((err) => {
      Swal.showValidationMessage(`Erreur : ${err.message}`)
    })
}
